module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="apexchat_scripts_time_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n    class="livechat_message_wrapper apexchat_question_type_custom_style_div apexchat_question_type_confirm_or_skip apexchat_message';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += '">\r\n    <div class="apexchat_question_type_single_col">\r\n        <div class="apexchat_speaker">\r\n            <div class="apexchat_question_type_confirm_or_skip" id="apexchat_question_type_div_close_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n                <div title="Close" id="apexchat-btn-skip-' +
((__t = (id)) == null ? '' : __t) +
'"\r\n                    class="apexchat_question_type_close_button apexchat_element_on_focus"></div>\r\n            </div>\r\n            <!-- <div class="qt-user apexchat_speaker apexchat_participant_display_text"\r\n                id="apexchat_participant_display_name">\r\n                ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
'\r\n            </div>\r\n            <div class="apexchat_speaker apexchat_participant_display_text" id="apexchat_participant_display_col">:&nbsp\r\n            </div> -->\r\n            <div class="apexchat_text apexchat_participant_display_text" tabindex="0"\r\n                id="apexchat_participant_display_text">\r\n                ' +
((__t = (text )) == null ? '' : __t) +
'\r\n            </div>\r\n        </div>\r\n\r\n        <div class="apexchat_question_scripts_time" id="apexchat_question_type_time_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n            <select id="apexchat_question_type_time_select_control_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n                class="apexchat_dynamic_question_type_input_controls apexchat_element_on_focus">\r\n                apexchat_options_div\r\n            </select>\r\n        </div>\r\n        <div class="apexchat_question_confirm_or_skip_padding" id="apexchat_question_type_div_confirm_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n            <!-- aria-hidden to avoid double reading. -->\r\n            <span id="apexchat-btn-confirm-' +
((__t = (id)) == null ? '' : __t) +
'" class="apexchat_ada_compliance apexchat_element_on_focus"\r\n                tabindex="0" title="Send" role="button">Send <img\r\n                    src="https://adcc0b6fec71f6da6868-9951c12eaf763ebd0692efbd5797203c.ssl.cf2.rackcdn.com/Chevron_right.svg.png"\r\n                    style="height: 10px;width: 10px;" alt="Send" aria-hidden="true"></span>\r\n            <br /><br /><br />\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}